import { SYNC_KEY_COSTOS_GANADERIA } from "../../../constantes";
import { CostosPlataformaService, TarifaDataAgItem } from "../../generated/grpc/plataforma_costos_pb";
import { CostoGanaderiaResponse } from "../../response/costos/CostoGanaderiaResponse";
import { ServiceGetListBase } from "../base/ServiceGetListBase";
import { grpcCall, grpcClient } from "../grpc/grpcCall";

/** Tramos de DATA AG ganadería (`CostosPlataformaService`, gRPC). Pipeline los reusa para cotizar. */
export class CostoGanaderiaListService extends ServiceGetListBase<CostoGanaderiaResponse> {
  static readonly instance = new CostoGanaderiaListService();
  private constructor() { super(); }

  /** Clave única del listado: deduplica `sync()` (dos pedidos simultáneos, un solo request). */
  protected readonly syncKey = SYNC_KEY_COSTOS_GANADERIA;

  /** gRPC-Web (`ListGanaderia`): no eliminados, por orden. */
  protected async fetchItems(): Promise<CostoGanaderiaResponse[]> {
    const r = await grpcCall(() => grpcClient(CostosPlataformaService).listGanaderia({}));
    return r.items.map(toCostoGanaderiaResponse);
  }
}

/** Mensaje gRPC del tramo → respuesta. Sin precio = negociación directa. */
export function toCostoGanaderiaResponse(t: TarifaDataAgItem): CostoGanaderiaResponse {
  const precioAnual = t.precioAnual !== undefined ? Number(t.precioAnual) : null;
  return {
    id: t.id,
    isEliminado: false,
    rango: t.rango,
    topeMaximoHa: t.topeMaximoHa ?? null,
    precioAnual,
    isNegociacion: precioAnual === null,
    orden: t.orden,
  };
}
